import { ILoggerState } from './LoggerSlice';
import { createSelector } from "@reduxjs/toolkit";


export const selectLoggerState = (state: RootState) => state.logger;
export const selectLoggerLogs = (logger: ILoggerState) => logger.logs;
export const selectLoggerInfo = (logger: ILoggerState) => {
    return {
        serverState: logger.serverState,
        deviceState: logger.deviceState,
        deviceDisplayState: logger.deviceDisplayState,
        deviceSpeechState: logger.deviceSpeechState,
    }
};
export const selectLoggerIsConnected = (logger: ILoggerState) => logger.isConnected;
